export default __webpack_public_path__ + "ui/assets/img/calls-slider-20.svg";